import _extends from "@babel/runtime/helpers/esm/extends";
var openStatusReducerGen = function openStatusReducerGen(args) {
  var readonly = args.readonly,
    disabled = args.disabled,
    keyboardControlAreaDispatch = args.keyboardControlAreaDispatch,
    activeStartDateDispatch = args.activeStartDateDispatch,
    viewDispatch = args.viewDispatch,
    dateValidator = args.dateValidator,
    maxDetail = args.maxDetail,
    minDate = args.minDate,
    maxDate = args.maxDate,
    disabledDays = args.disabledDays,
    disabledDates = args.disabledDates,
    disabledRanges = args.disabledRanges,
    dateCalculator = args.dateCalculator,
    valueDispatch = args.valueDispatch,
    inputValueDispatch = args.inputValueDispatch,
    format = args.format,
    mergedDisabledDatesIntervals = args.mergedDisabledDatesIntervals;
  // @ts-ignore
  var focusTrapInst = window.trap;
  return function (state, action) {
    if (readonly || disabled) {
      return {
        isOpen: state.isOpen
      };
    }
    var payload = action.payload;
    var _ref = payload || {},
      inputValue = _ref.inputValue,
      selectRange = _ref.selectRange,
      mode = _ref.mode,
      isKeyboard = _ref.isKeyboard,
      editForbidden = _ref.editForbidden,
      panelValue = _ref.panelValue;
    var isValidByRule = false;
    var isValidFormat = false;
    var value = null;
    var newInputValue = inputValue;
    var autoComplete = false;
    switch (action.type) {
      case 'open':
        if (isKeyboard) focusTrapInst && focusTrapInst.pause();
        return {
          isOpen: true
        };
      case 'close':
        if (isKeyboard) focusTrapInst && focusTrapInst.unpause();
        return {
          isOpen: false
        };
      case 'closeWithValidation':
        if (isKeyboard) focusTrapInst && focusTrapInst.unpause();
        if (selectRange || mode === 'showRangePanel' && inputValue && inputValue.length > 10) {
          isValidByRule = dateValidator.isValidRangeDateByRules({
            date: inputValue,
            minDate: minDate,
            maxDate: maxDate,
            disabledDays: disabledDays,
            disabledDates: disabledDates,
            disabledRanges: disabledRanges
          }, mergedDisabledDatesIntervals);
          if (selectRange && inputValue && inputValue.length === format.length) {
            var isValid = dateValidator === null || dateValidator === void 0 ? void 0 : dateValidator.isValidFormatDateString(inputValue);
            if (isValid) {
              if (inputValue !== '') {
                autoComplete = true;
              }
            }
          }
        } else {
          isValidByRule = dateValidator === null || dateValidator === void 0 ? void 0 : dateValidator.isValidSingleDateByRules({
            date: inputValue,
            minDate: minDate,
            maxDate: maxDate,
            disabledDays: disabledDays,
            disabledDates: disabledDates,
            disabledRanges: disabledRanges
          }, mergedDisabledDatesIntervals);
        }
        if (autoComplete) {
          newInputValue = dateCalculator.calculateDatestringFromDateValues(inputValue, inputValue, true);
        }
        isValidFormat = dateValidator === null || dateValidator === void 0 ? void 0 : dateValidator.isValidFormatDateString(newInputValue || '');
        //setHasInputError(!isValidByRule || !isValidFormat);
        keyboardControlAreaDispatch({
          type: 'clearNav'
        });
        viewDispatch({
          type: 'goTargetView',
          payload: {
            targetView: maxDetail || 'month'
          }
        });
        if (isValidFormat) {
          value = dateCalculator.calculateDateValuesFromDateString(newInputValue || '');
        }
        if (!editForbidden) valueDispatch({
          type: 'setValue',
          payload: {
            value: value
          }
        });
        if (autoComplete && !editForbidden) {
          inputValueDispatch({
            type: 'setInputValueByString',
            payload: {
              value: newInputValue
            }
          });
        }
        if (!editForbidden) {
          if (!value) {
            activeStartDateDispatch({
              type: 'reset',
              payload: {}
            });
          } else {
            activeStartDateDispatch({
              type: 'setActiveStartDateByValue',
              payload: {
                value: value
              }
            });
          }
        } else {
          if (!panelValue) {
            activeStartDateDispatch({
              type: 'reset',
              payload: {}
            });
          } else {
            activeStartDateDispatch({
              type: 'setActiveStartDateByValue',
              payload: {
                value: panelValue
              }
            });
          }
        }
        return {
          isOpen: false
        };
      case 'openWithValidation':
        if (isKeyboard) focusTrapInst && focusTrapInst.pause();
        newInputValue = inputValue;
        autoComplete = false;
        isValidByRule = dateValidator.isValidDateValueByRules({
          date: newInputValue,
          minDate: minDate,
          maxDate: maxDate,
          disabledDays: disabledDays,
          disabledDates: disabledDates,
          disabledRanges: disabledRanges
        });
        if (selectRange && inputValue && inputValue.length === format.length) {
          var _isValid = dateValidator === null || dateValidator === void 0 ? void 0 : dateValidator.isValidFormatDateString(inputValue);
          if (_isValid) {
            if (inputValue !== '') {
              autoComplete = true;
              newInputValue = dateCalculator.calculateDatestringFromDateValues(inputValue, inputValue, true);
            }
          }
        }
        isValidFormat = dateValidator.isValidFormatDateString(newInputValue || '');
        if (isValidFormat) {
          value = dateCalculator.calculateDateValuesFromDateString(newInputValue || '');
        }
        viewDispatch({
          type: 'goTargetView',
          payload: {
            targetView: maxDetail || 'month'
          }
        });
        if (!editForbidden) valueDispatch({
          type: 'setValue',
          payload: {
            value: value
          }
        });
        if (!editForbidden) {
          if (!value) {
            activeStartDateDispatch({
              type: 'reset',
              payload: {}
            });
            if (autoComplete) {
              inputValueDispatch({
                type: 'setInputValueByString',
                payload: {
                  value: newInputValue
                }
              });
            }
          } else {
            activeStartDateDispatch({
              type: 'setActiveStartDateByValue',
              payload: {
                value: value
              }
            });
          }
        } else {
          if (!panelValue) {
            activeStartDateDispatch({
              type: 'reset',
              payload: {}
            });
          } else {
            activeStartDateDispatch({
              type: 'setActiveStartDateByValue',
              payload: {
                value: panelValue
              }
            });
          }
        }
        return _extends({}, state, {
          isOpen: true
        });
    }
  };
};
export default openStatusReducerGen;